export const IDENTIFIER_PATTERN = '[A-Za-z_][A-Za-z0-9_]*';

const IDENTIFIER = new RegExp(`^${IDENTIFIER_PATTERN}$`);

export function variableNameProblem(name: string, taken: Iterable<string> = []): string | null {
  if (name === '') return 'A variable needs a name';
  if (!IDENTIFIER.test(name)) {
    return `"${name}" is not a valid name: use letters, digits and _, and do not start with a digit`;
  }
  for (const other of taken) {
    if (other === name) return `A variable named "${name}" already exists`;
  }
  return null;
}
